// icons
import { FaEnvelope, FaHome, FaPhone } from "react-icons/fa";

// components
import Hero from "../components/Hero";

const AboutUs = () => {
  return (
    <>
      <Hero
        title="About Us"
        breadName="About"
        // image={contactBg}
        singleProduct={false}
      />
      <section className="py-5">
        <h1 className="display-1 text-center">Delightye</h1>
      </section>
    </>
  );
};

export default AboutUs;
